import { action, makeObservable, observable } from 'mobx';

export enum Brand {
  TELIA = 'telia',
  DIIL = 'diil'
}

export default class BrandfulStore {
  public static DEFAULT_BRAND = Brand.TELIA;

  @observable public currentBrand: Brand;
  icons: Record<string, any> = {
    '#arrow-right': require('@teliaee/icons/svg/arrow-right.svg'),
    '#check': require('@teliaee/icons/svg/check.svg'),
    '#check-round': require('@teliaee/icons/svg/check-round.svg'),
    '#alert-filled': require('@teliaee/icons/svg/alert.svg'),
    '#arrow-left': require('@teliaee/icons/svg/arrow-left.svg')
  };

  constructor() {
    makeObservable(this);
    this.setNewBrand(BrandfulStore.DEFAULT_BRAND);
  }

  @action
  public setNewBrand(brand: string) {
    this.currentBrand = brand.toLowerCase() === Brand.DIIL ? Brand.DIIL : Brand.TELIA;
  }

  public getIconPath = (name: string) => {
    if (this.icons[name]) {
      if (this.icons[name].symbol) {
        return this.icons[name].symbol;
      } else {
        return this.icons[name];
      }
    }
    return name;
  };
}
